export default __webpack_public_path__ + "static/media/home-icon.16040452.svg";